import { PrismicNextImage } from '@prismicio/next';
import { asText, Content } from '@prismicio/client';

import { Box, Heading } from '@preventx/oxygen';
import { RichText } from '@preventx/prismic-services';

// Services
import { applicationEnv } from '@/services/env/shared';

type WithMarqueeProps = {
  sliceId: string;
  slice: Content.RegionSliceWithMarquee;
};

export const WithMarquee = ({ sliceId, slice }: WithMarqueeProps) => {
  const { primary } = slice;
  const { title, content, image_group_one } = primary;

  const { WebsiteUrl } = applicationEnv();

  return (
    <>
      <Box component="div" className="marquee-wrapper-vertical animate">
        {image_group_one.length > 0 && (
          <Box
            component="div"
            className="marquee"
            data-fit-content=""
            data-pos-absolute=""
            data-orientation="vertical"
          >
            <Box component="div" className="marquee__content">
              {(image_group_one ?? []).map(({ image }, index) => (
                <PrismicNextImage
                  field={image}
                  className="rounded-sm"
                  key={`marquee-group-one-visible-${sliceId}-${index + 1}`}
                />
              ))}
            </Box>

            <Box
              component="div"
              aria-hidden="true"
              className="marquee__content"
            >
              {(image_group_one ?? []).map(({ image }, index) => (
                <PrismicNextImage
                  field={image}
                  className="rounded-sm"
                  key={`marquee-group-one-visible-${sliceId}-${index + 1}`}
                />
              ))}
            </Box>
          </Box>
        )}
      </Box>

      <Box component="div" addFlow padding={{ py: 'py-4' }}>
        <Heading component="h3" className="marquee__title">
          {asText(title)}
        </Heading>

        <RichText content={content} variant="default" websiteUrl={WebsiteUrl} />
      </Box>
    </>
  );
};
